module.exports = __webpack_public_path__ + "static/media/PDF_124.d304c9b2.pdf";